import { useContext, useRef } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    InputAdornment,
    Typography,
    IconButton,
    CircularProgress
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Close } from '@mui/icons-material';
// Our Components
import { CardContext } from 'context/cards/cardContext';
import { CLOSE_REQUEST_EDIT_CARD_LIMIT_MODAL, GET_CARDS } from 'context/cards/types';
import SnackBarComponent from 'components/shared/SnackBarComponent';
// Services
import { Cards } from 'lib/api';
// Assets
import './RequestEditLimitModal.css';

const INITIAL_VALUES = {
    limitAmount: ''
};
const APPROVAL_SCHEMA = Yup.object().shape({
    limitAmount: Yup.number().typeError('Limit amount must be a number').min(1, 'Invalid amount').required('Required')
});
const RequestEditLimitModal = () => {
    const { isRequestEditLimitModalOpen, cardToRequestEditLimit, dispatch } = useContext(CardContext);
    const SnackBarRef = useRef(null);

    const handleRequestEditLimitModalClose = () => {
        dispatch({ type: CLOSE_REQUEST_EDIT_CARD_LIMIT_MODAL });
    };

    const handleSendRequest = async values => {
        try {
            await Cards.requestLimitChange(cardToRequestEditLimit.id, { requestedLimitAmount: values.limitAmount });
            dispatch({ type: GET_CARDS });
            dispatch({ type: CLOSE_REQUEST_EDIT_CARD_LIMIT_MODAL });
            SnackBarRef.current.openSnackBar({
                label: 'Request sent successfully',
                severity: 'success'
            });
        } catch (error) {
            SnackBarRef.current.openSnackBar({
                label: 'An unexpected error occurred. Please try again.',
                severity: 'error'
            });
        }
    };

    return (
        <>
            <Dialog open={isRequestEditLimitModalOpen} onClose={() => {}}>
                <DialogContent sx={{ padding: '32px', width: '600px' }}>
                    <Formik initialValues={INITIAL_VALUES} validationSchema={APPROVAL_SCHEMA} onSubmit={handleSendRequest}>
                        {({ isValid, dirty, isSubmitting }) => (
                            <Form>
                                <Box sx={{ paddingBottom: '10px' }}>
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <Typography className="request-edit-limit-modal__form-title">
                                                Request Limit Change
                                            </Typography>
                                            <IconButton onClick={handleRequestEditLimitModalClose}>
                                                <Close sx={{ fontSize: '20px', cursor: 'pointer' }} />
                                            </IconButton>
                                        </Box>
                                        <Typography className="request-edit-limit-modal__form-subtitle">
                                            New limit request will be sent to your admin
                                        </Typography>
                                    </Box>

                                    <Box sx={{ marginBottom: '10px' }}>
                                        <Typography className="request-edit-limit-modal__text-secondary">
                                            Current Card Limit
                                        </Typography>
                                        <Typography className="request-edit-limit-modal__form-title">{`$${cardToRequestEditLimit.limitAmount}`}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography className="request-edit-limit-modal__text-secondary">
                                            Request New Limit
                                        </Typography>
                                        <Field
                                            type="text"
                                            name="limitAmount"
                                            component={TextField}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AttachMoneyIcon fontSize="small" />
                                                    </InputAdornment>
                                                )
                                            }}
                                            placeholder="Enter amount"
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                        />
                                    </Box>
                                </Box>
                                <DialogActions sx={{ marginTop: '20px', padding: '0px' }}>
                                    <Button type="submit" variant="contained" disabled={!isValid || !dirty || isSubmitting}>
                                        {isSubmitting ? <CircularProgress size="20px" /> : 'Send Request'}
                                    </Button>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
            <SnackBarComponent ref={SnackBarRef} />
        </>
    );
};

export default RequestEditLimitModal;
